import React, { Component } from 'react'
import Button from '@material-ui/core/Button'
import { Link } from 'react-router-dom'
import Menu from './includes/Menu'
import { Grid } from '../../../node_modules/@material-ui/core';

const lang = '';

class PressCenter extends Component {
  constructor(props) {
    super(props);
    //console.log('constructor');
    //console.log(props);
    this.lang = (props.lang) ? props.lang : '';
    //console.log('constructor, this.lang:', this.lang);
  }

  componentDidMount() {
    document.title = this.getLangText({
      'tc': '新聞中心',
      'sc': '新闻中心',
      'en': 'News Center'
    });
  }

  getLangText(langJson) {
    return (this.lang) ? langJson[this.lang] : langJson['tc'];
  }

  getLink(page){
    return (this.lang) ? '/' + this.lang + '/' + page : '/' + page;
  }

  render(){
    return(
      PressCenterJSX(this)
    );
  }
}

const PressCenterJSX = (ctx) => (
  <div className={ (ctx.lang === 'en' ? 'en' : '') }>
    <Menu lang={ ctx.lang } />
  
    <div className='main-content-container'>
      <div className='main-content-inner-wrapper news'>
        <Grid container spacing={0}>
          <Grid item id='page-title'>
            <span>
              {
                ctx.getLangText({
                  'tc': '新聞中心',
                  'sc': '新闻中心',
                  'en': 'News Center'
                })
              }
            </span>
          </Grid>
          <Grid item style={{width:'100%', marginBottom:'30px'}}><hr/></Grid>
        </Grid>
        <div style={{clear:'both'}}></div>

        <div className='presscenter-content-container'>
          <Grid container className='section' spacing={0}>
            <Button>
              <Link to={ ctx.getLink('pc-20171212001') }>
                <Grid container spacing={0}>
                  <Grid item xs={12} sm={12} md={2} className='news-date'>
                    <span>2017.12.12</span>
                  </Grid>
                  <Grid item xs={12} sm={12} md={10} className='news-content'>
                      <span className='news-title'>
                        {
                          ctx.getLangText({
                            'tc': '鑫匯寶貴金屬榮獲2017傑出金商增值服務大獎',
                            'sc': '鑫汇宝贵金属荣获2017杰出金商增值服务大奖',
                            'en': 'Xinhuibao Precious Metals won Best Investment Value Award 2017'
                          })
                        }
                      </span>
                      <br/>
                      <span className='news-desc'>
                        {
                          ctx.getLangText({
                            'tc': '鑫匯寶貴金屬榮獲2017傑出金商增值服務大獎香港鑫匯寶貴金屬有限公司多年來誠信經營，用心服務...',
                            'sc': '鑫汇宝贵金属荣获2017杰出金商增值服务大奖香港鑫汇宝贵金属有限公司多年来诚信经营，用心服务...',
                            'en': 'Xinhuibao Precious Metals won Best Investment Value Award 2017, Hong Kong Xinhuibao Precious Metals Co., Ltd., Integrity management for many years, dedicated service ...'
                          })
                        }
                      </span>
                  </Grid>
                </Grid>
              </Link>
            </Button>
          </Grid>

          <Grid container className='section' spacing={0}>
            <Button>
              <Link to={ ctx.getLink('pc-20161218001') }>
                <Grid container spacing={0}>
                  <Grid item xs={12} sm={12} md={2} className='news-date'>
                    <span>2016.12.18</span>
                  </Grid>
                  <Grid item xs={12} sm={12} md={10} className='news-content'>
                      <span className='news-title'>
                        {
                          ctx.getLangText({
                            'tc': '鑫匯寶貴金屬榮獲2016傑出金商增值服務大獎',
                            'sc': '鑫汇宝贵金属荣获2016杰出金商增值服务大奖',
                            'en': 'Xinhuibao Precious Metals won Best Investment Value Award 2016'
                          })
                        }
                      </span>
                      <br/>
                      <span className='news-desc'>
                        {
                          ctx.getLangText({
                            'tc': `近日，匯寶資本集團旗下鑫匯寶貴金屬有限公司有幸慘加由《Let's go投資先機》雜誌、知名材經機構以及各大傳媒聯合舉辦的2016年最具投資價值上市公司頒獎典禮...`,
                            'sc': `近日，汇宝资本集团旗下鑫汇宝贵金属有限公司有幸惨加由《Let's go投资先机》杂志、知名材经机构以及各大传媒联合举办的2016年最具投资价值上市公司颁奖典礼`,
                            'en': `Xinhuibao Precious Metals Co., Ltd., a subsidiary of Huibao Capital Group, fortunate to have join the awards ceremony of the 2016 Most Investing Value Listed Company by the "Let's Go Investment Opportunity" magazine, well-known materials and organizations and major media ...`
                          })
                        }
                      </span>
                  </Grid>
                </Grid>
              </Link>
            </Button>
          </Grid>

          <Grid container className='section' spacing={0}>
            <Button>
              <Link to={ ctx.getLink('pc-20161118001') }>
                <Grid container spacing={0}>
                  <Grid item xs={12} sm={12} md={2} className='news-date'>
                    <span>2016.11.18</span>
                  </Grid>
                  <Grid item xs={12} sm={12} md={10} className='news-content'>
                      <span className='news-title'>
                        {
                          ctx.getLangText({
                            'tc': `鑫匯寶貴金屬榮膺“最佳黃金交易平台”獎`,
                            'sc': `鑫汇宝贵金属荣膺“最佳黄金交易平台”奖`,
                            'en': `Xinhuibao Precious Metals won the China Financial Annual Champion Best Precious Metals Trading Platform Awards`
                          })
                        }
                      </span>
                      <br/>
                      <span className='news-desc'>
                        {
                          ctx.getLangText({
                            'tc': `近日，第13屆中國材經風雲榜黃金行業頒獎典禮在深圳隆重舉行。眾多金企慘與此次最具權威性和影響力的行業評選活動。根據評...`,
                            'sc': `近日，第13届中国材经风云榜黄金行业颁奖典礼在深圳隆重举行。众多金企惨与此次最具权威性和影响力的行业评选活动。根据评`,
                            'en': `The 13th China Financial Annual Champion Awards - precious metals Business, the award ceremony was held in Shenzhen. Many precious Metals Merchants participated in this most authoritative and influential industry selection activity. According to ...`
                          })
                        }
                      </span>
                  </Grid>
                </Grid>
              </Link>
            </Button>
          </Grid>

          <Grid container className='section' spacing={0}>
            <Button>
              <Link to={ ctx.getLink('pc-20160403001') }>
                <Grid container spacing={0}>
                  <Grid item xs={12} sm={12} md={2} className='news-date'>
                    <span>2016.04.03</span>
                  </Grid>
                  <Grid item xs={12} sm={12} md={10} className='news-content'>
                      <span className='news-title'>
                        {
                          ctx.getLangText({
                            'tc': `鑫匯寶貴金屬獲“2015十佳黃金交易平台”殊榮`,
                            'sc': `鑫汇宝贵金属获“2015十佳黄金交易平台”殊荣`,
                            'en': `Xinhuibao Precious Metals won the "2015 Top Ten Gold Trading Platform"`
                          })
                        }
                        
                      </span>
                      <br/>
                      <span className='news-desc'>
                        {
                          ctx.getLangText({
                            'tc': `近日，由中金在線、黃金網、外匯網聯合主辦的”2015年度財經排行榜、財經博客排行榜頒獎盛典”在福州成功舉辦。本年度財經排行榜...`,
                            'sc': `近日，由中金在线、黄金网、外汇网联合主办的"2015年度财经排行榜、财经博客排行榜颁奖盛典"在福州成功举办。本年度财经排行榜`,
                            'en': `"2015 Annual Rankings and Financial Blogger Ranking Awards Ceremony" jointly sponsored by China Financial Online (CNFOL), Gold  Network and Foreign Exchange Network was successfully held in Fuzhou. This year's rankings ...`
                          })
                        }
                      </span>
                  </Grid>
                </Grid>
              </Link>
            </Button>
          </Grid>

        </div>

      </div>
    </div>
  </div>
)

export default PressCenter



// WEBPACK FOOTER //
// ./src/components/pages/PressCenter.js